






export default {
  name: 'epb-loader',
  props: {
    inverse: Boolean
  }
};
